import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { navigateToCategory } from "../../../utils/utils";
import Translate from "../../../Components/Multilanguage/Translate";

const ListView = ({
  events,
  date,
  calendarView = false,
  onDeleteVideo,
  onVideoComplete,
  appInfo,
  user,
  redirectToLogin,
  loading,
}) => {
  const navigate = useNavigate();
  const today = new Date();
  const viewedEvents = calendarView
    ? events
    : events.filter(
        (event) => new Date(event.start).toDateString() >= today.toDateString()
      );
  const [hoveredTickId, setHoveredTickId] = useState(null);

  const handleView = (event) => {
    navigate(`/videos/${event.id}`);
  };

  const handleDelete = (event) => {
    if (onDeleteVideo && event.calendar_id) {
      onDeleteVideo(event.calendar_id);
    }
  };

  const handleCategoryClick = (partnerId) => {
    navigate(`/partner/${partnerId}`, { state: { partnerId } });
  };

  return (
    <div className="agenda-view">
    {loading ? (
                <div className="loader">
                <div className="loader-spinner"></div>
              </div>
      ) : (
      <ul>
        {viewedEvents && viewedEvents.length > 0 ? (
          viewedEvents.map((event, index) => (
            <li
              key={index}
              className={`agenda-item ${
                hoveredTickId === event.calendar_id ? "tick-hovered" : ""
              }`}
            >
              <div className="event-details">
                <img
                  src={event?.image}
                  alt={event?.title}
                  className="event-image"
                  onClick={() => handleView(event)}
                />
                <div className="event-info">
                  <h1 onClick={() => handleView(event)}>{event?.title}</h1>
                  <div className="event-meta">
                    {event?.partner?.name && (
                      <span className="category" 
                      onClick={() => handleCategoryClick(event?.partner?.partner_id)}
                      >
                        {event?.partner?.image ? (
                          <img src={event.partner.image} />
                        ) : (
                          <div className="icon">👤</div>
                        )}{" "}
                        <div classname="categoryName">
                          {event?.partner?.name}
                        </div>
                      </span>
                    )}
                    <span>
                      <div className="icon">⏱</div> <div>{event?.duration}</div>
                    </span>
                  </div>
                  <p>{event?.description}</p>
                </div>
                <div
                  className={`tick-icon ${event?.completed ? "completed" : ""}`}
                  onClick={() => {
                    if (!user) {
                      redirectToLogin();
                    } else {
                      onVideoComplete(event.calendar_id, !event.completed);
                    }
                  }}
                  onMouseEnter={() => setHoveredTickId(event.calendar_id)}
                  onMouseLeave={() => setHoveredTickId(null)}
                >
                  <i className="fas fa-check"></i>
                </div>
              </div>
              <div
                className={`external-action-buttons ${
                  !event?.is_user_video ? "no-delete" : ""
                }`}
              >
                <div className="action-half" onClick={() => handleView(event)}>
                  <Translate textKey={"watch"} /> ⯈
                </div>
                {event?.is_user_video && (
                  <div
                    className="action-half"
                    onClick={() => handleDelete(event)}
                  >
                    🗑 <Translate textKey={"delete"} />
                  </div>
                )}
              </div>
            </li>
          ))
        ) : (
          <p><Translate textKey={"no_videos_scheduled"} /></p>
        )}
      </ul>
      )}
    </div>
  );
};

export default ListView;
